module.exports = __webpack_public_path__ + "static/media/Screenshot5.4e76d374.png";